import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Link } from 'wouter';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, TrendingUp, Leaf, Satellite, MapPin, Zap } from "lucide-react";

export default function Tecnologias() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="relative text-primary-foreground h-[265px] flex items-center" style={{backgroundImage: "url('/images/pages/hero-azul.webp')", backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: "0 0 96px 0", overflow: "hidden", boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)"}}>
          <div className="absolute inset-0" style={{background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0) 100%)"}}></div>
          <div className="container relative z-10">
            <h1 className="text-5xl md:text-6xl font-serif text-center font-bold" style={{fontFamily: "'Suez One', serif"}}>
              Tecnologias
            </h1>
          </div>
        </section>

        {/* Atfarm - Mapeamento de Aplicação */}
        <section className="py-20 md:py-32 bg-background">
          <div className="container">
            {/* Header */}
            <div className="text-center mb-16">
              <p className="text-sm md:text-base font-semibold text-primary uppercase tracking-wider mb-4">MAPEAMENTO DE APLICAÇÃO</p>
              <img loading="lazy" src="/images/atfarm-logo.svg" alt="Atfarm Logo" className="h-12 mx-auto mb-8" />
              <h2 className="text-4xl md:text-5xl font-serif mb-6 text-primary font-bold" style={{fontFamily: "'Suez One', serif"}}>
                Aplique fertilizantes com precisão facilmente
              </h2>
              <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
                Crie mapas de aplicação de fertilizantes em taxa variável com o Atfarm, usando imagens de satélite de última geração.
              </p>
            </div>

            {/* Main Content - Grid 2 columns */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch mb-12">
              {/* Image */}
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img loading="lazy" src="/images/nova_tecnologia.webp" alt="Atfarm - Mapeamento de Aplicação" className="w-full h-full object-cover" style={{objectPosition: 'right center'}} />
              </div>
              
              {/* Features Cards */}
              <div className="space-y-6 flex flex-col">
                {/* Card 1 - Economize */}
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 hover:shadow-lg transition-all flex-1" style={{backgroundColor: 'rgba(173, 216, 230, 0.15)', border: '2px solid #ADD8E6'}}>
                  <CardContent className="p-6 flex gap-4 h-full flex-col justify-center">
                    <div className="w-12 h-12 rounded-lg bg-green-500/20 flex items-center justify-center flex-shrink-0">
                      <DollarSign className="w-6 h-6 text-green-600" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-foreground mb-2" style={{fontFamily: "'Suez One', serif"}}>ECONOMIZE</h3>
                      <p className="text-sm text-muted-foreground">Otimize a eficiência da aplicação de fertilizantes ao aprimorar a distribuição de nitrogênio com a tecnologia de aplicação em taxa variável.</p>
                    </div>
                  </CardContent>
                </Card>

                {/* Card 2 - Otimize */}
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 hover:shadow-lg transition-all flex-1" style={{backgroundColor: 'rgba(100, 200, 255, 0.15)', border: '2px solid #64C8FF'}}>
                  <CardContent className="p-6 flex gap-4 h-full flex-col justify-center">
                    <div className="w-12 h-12 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                      <Leaf className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-foreground mb-2" style={{fontFamily: "'Suez One', serif"}}>OTIMIZE A ADUBAÇÃO</h3>
                      <p className="text-sm text-muted-foreground">Personalize a aplicação de Nitrogênio conforme as distintas demandas de cada área do seu talhão. Aplique a dose mais adequada para otimizar os resultados.</p>
                    </div>
                  </CardContent>
                </Card>

                {/* Card 3 - Aumente */}
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30 hover:shadow-lg transition-all flex-1" style={{backgroundColor: 'rgba(255, 192, 203, 0.15)', border: '2px solid #FFC0CB'}}>
                  <CardContent className="p-6 flex gap-4 h-full flex-col justify-center">
                    <div className="w-12 h-12 rounded-lg bg-pink-500/20 flex items-center justify-center flex-shrink-0">
                      <TrendingUp className="w-6 h-6 text-pink-600" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-foreground mb-2" style={{fontFamily: "'Suez One', serif"}}>AUMENTE A SUA PRODUTIVIDADE</h3>
                      <p className="text-sm text-muted-foreground">Maximize sua rentabilidade ao utilizar a aplicação de fertilizantes em taxa variável, diminuindo desperdícios e otimizando a eficiência.</p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Bottom Text */}
            <div className="bg-muted/30 rounded-2xl p-8 text-center space-y-4">
              <p className="text-base text-muted-foreground leading-relaxed">
                Nós nos concentramos em fornecer uma ferramenta que propicie uma experiência única para sua adubação.
              </p>
              <p className="text-base text-muted-foreground leading-relaxed">
                Permitimos que você assuma o controle de sua estratégia de adubação, adaptando-a de acordo com seu conhecimento sobre seus talhões.
              </p>
              <p className="text-base text-muted-foreground leading-relaxed">
                Você pode criar um mapa de aplicação e fazer modificações antes de exportá-lo e levá-lo até o seu maquinário em um pendrive.
              </p>
            </div>
          </div>
        </section>

        {/* Pronto para revolucionar... */}
        <section className="py-20 md:py-32 bg-secondary text-secondary-foreground">
          <div className="container text-center">
            <h2 className="text-4xl md:text-5xl font-serif mb-8 font-bold" style={{fontFamily: "'Suez One', serif"}}>
              Pronto para revolucionar sua lavoura?
            </h2>
            <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto">
              Entre em contato conosco e descubra como a agricultura de precisão pode transformar seus resultados.
            </p>
            <Link href="/contato" onClick={scrollToTop}>
              <span className="inline-block bg-accent hover:bg-accent/90 text-accent-foreground font-bold py-3 px-8 rounded-lg transition-colors cursor-pointer">
                FALE COM NOSSOS ESPECIALISTAS
              </span>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

